<template>
  <div class="examineBox">
    <div class="containter" v-loading='loading'>
      <div class="listBox">
        <div style="display:flex;align-items:center;flex-wrap:wrap;padding:0 10px">
          <label class="label_name mb-10">结算公司：</label>
          <el-select class="input mb-10" v-model="company" style="width:180px" size='mini' filterable placeholder="请选择签约公司" @change="getInvoiceList(1)" clearable>
            <el-option v-for="(item,index) in signCompanyList" :key="index" :label="item.company" :value="item.company" />
          </el-select>

          <label class="label_name mb-10">所属年月：</label>
          <el-date-picker class="mb-10" v-model="month" type="monthrange" align="right" unlink-panels range-separator="至" start-placeholder="开始年月" end-placeholder="结束年月" clearable value-format="yyyy-MM" @change="getInvoiceList(1)" size="mini" style="width:200px;margin-left:10px;" />

          <label class="label_name mb-10">结算单号：</label>
          <el-input class="mb-10" placeholder="请输入结算单序列号" v-model.trim="statements_id" clearable @keydown.enter.native="statements_id?getInvoiceList(1):''" @clear="getInvoiceList(1)" size="mini" style="width:200px;margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="statements_id?getInvoiceList(1):''" style="padding:0 10px" />
          </el-input>

          <label class="label_name mb-10">客户名称：</label>
          <el-input class="mb-10" placeholder="请输入客户名称" v-model.trim="customer_name" clearable @keydown.enter.native="customer_name?getInvoiceList(1):''" @clear="getInvoiceList(1)" size="mini" style="width:200px;margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="customer_name?getInvoiceList(1):''" style="padding:0 10px" />
          </el-input>

          <label class="label_name mb-10">项目名称：</label>
          <el-input class="mb-10" placeholder="请输入项目名称" v-model.trim="project_name" clearable @keydown.enter.native="project_name?getInvoiceList(1):''" @clear="getInvoiceList(1)" size="mini" style="width:200px;margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="project_name?getInvoiceList(1):''" style="padding:0 10px" />
          </el-input>

          <label class="label_name mb-10">归档日期：</label>
          <el-date-picker class="mb-10" @change="getInvoiceList(1)" v-model="fileDate" style="width:220px;margin-left:10px;" type="daterange" size="mini" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />

          <label class="label_name mb-10">归档状态：</label>
          <el-select class="input mb-10" v-model="file_status" style="width:180px" size='mini' filterable placeholder="请选择归档状态" @change="getInvoiceList(1)" clearable>
            <el-option label="未归档" :value="1" />
            <el-option label="已归档" :value="2" />
          </el-select>

          <div class="batchBox mb-10 ml-20">
            <div class="batchDelete active" style="margin-left:0" @click="onClickExport">导出</div>
          </div>

        </div>
        <el-table class="table" style="margin-top:5px;" ref="multipleTable" :header-cell-style="{background:'#f5f7fa'}" :data="accountList" height="calc(100vh - 204px)" border>
          <el-table-column prop="statements_id" label="结算单号" align='center' width="94" fixed="left" />
          <el-table-column prop="company" label="结算公司" align='center' min-width="100" />
          <el-table-column prop="customer_name" label="客户名称" align='center' min-width="100" />
          <el-table-column prop="order_year" label="所属年" align='center' min-width="100" />
          <el-table-column prop="order_month" label="所属月" align='center' min-width="100" />
          <el-table-column prop="order_amount" label="金额" align='center' width="90" />
          <el-table-column prop="saler" align='center' label="销售人员/mcn负责人" width="160" />
          <el-table-column prop="handler" align='center' label="经手人/mcn经手人" width="160" />
          <el-table-column prop="project_name" align='center' label="项目名称" width="200" />
          <el-table-column prop="file_date" align='center' label="归档日期" width="140">
            <template slot-scope="{ row }">
              <span>{{ row.file_date || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="file_remark" align='center' label="归档备注" width="120">
            <template slot-scope="{ row }">
              <span>{{ row.file_remark || '-' }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="file_status" align='center' label="归档状态" width="100">
            <template slot-scope="{ row }">
              <span v-if="row.file_status == 2" style="color:#00BB5D">已归档</span>
              <span v-else-if="row.file_status == 1">未归档</span>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getVerifyNoteColor } from '@/assets/js/tools.js'
export default {
  data () {
    return {
      statements_id: '',
      customer_name: '',
      project_name: '',
      page: 1,
      page_size: 50,
      total: 0,
      loading: false,
      accountList: [],
      company: '',
      file_status: '',
      signCompanyList: [],
      month: [],
      fileDate: [],
    }
  },
  created () {
    this.getSignCompanyList()
    this.getInvoiceList(1)
  },
  methods: {
    getVerifyNoteColor,

    handleCurrentChange (val) {
      this.getInvoiceList(val)
    },
    getInvoiceList (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.statementsSeal_detailList, {
        params: {
          statements_id: this.statements_id || 0,
          customer_name: this.customer_name,
          project_name: this.project_name,
          company: this.company,
          file_status: this.file_status || 0,
          order_month_start: this.month ? this.month[0] : '',
          order_month_end: this.month ? this.month[1] : '',
          file_date_start: this.fileDate ? this.fileDate[0] : '',
          file_date_end: this.fileDate ? this.fileDate[1] : '',
          page: page,
          page_size: this.page_size,
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSignCompanyList () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 1000
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.signCompanyList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    onClickExport() {
      this.$confirm('确定以当前筛选条件导出归档数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.get(this.URL.BASEURL + this.URL.statementsSeal_detailExport, {
          params: {
            statements_id: this.statements_id || 0,
            customer_name: this.customer_name,
            project_name: this.project_name,
            company: this.company,
            file_status: this.file_status || 0,
            order_month_start: this.month ? this.month[0] : '',
            order_month_end: this.month ? this.month[1] : '',
            file_date_start: this.fileDate ? this.fileDate[0] : '',
            file_date_end: this.fileDate ? this.fileDate[1] : '',
          },
        }).then((res) => {
          var res = res.data;
          this.loading = false;
          if (res && res.errno == 0) {
            this.exportEvent(res.rst)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }).catch(() => {})

    },
    exportEvent (file_url) {
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = file_url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
}
</script>
<style lang="scss" scoped>
.form-item {
  display: flex;
  align-items: center;
  margin-top: 20px;
  label {
    padding: 0 10px;
    width: 82px;
  }
  .el-input {
    width: 234px;
  }
}
/deep/.el-date-editor .el-range-separator {
  width: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.ml-20 {
  margin-left: 20px;
}
.signDate {
  /deep/.el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #666;
  }
}
.label_name {
  font-size: 13px;
  margin-left: 8px;
  // line-height: 30px;
}
.examineBox {
  .containter {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    padding-top: 15px;
    margin-top: 10px;
    .topOperation {
      padding: 16px;
      .title {
        font-size: 15px;
        color: #202652;
        line-height: 21px;
        font-weight: 500;
        display: inline-block;
        vertical-align: middle;
      }
      .selectBox {
        display: inline-block;
        vertical-align: middle;
        .selectItem {
          float: left;
          font-size: 13px;
          margin-left: 20px;
          cursor: pointer;
          .icon {
            width: 13px;
            height: 13px;
            border-radius: 3px;
            border: 1px solid #d2d2d2;
            display: inline-block;
            vertical-align: bottom;
            margin-right: 3px;
          }
          &.active {
            .icon {
              border-color: #2662ff;
              position: relative;
              &::before {
                content: "";
                display: inline-block;
                width: 7px;
                height: 7px;
                background: #2662ff;
                border-radius: 1px;
                position: absolute;
                top: 2px;
                left: 2px;
              }
            }
          }
        }
      }
    }
  }
  .table {
    width: calc(100% - 30px);
    margin: 0 15px;
  }
  .detailButton {
    min-width: 60px;
    height: 22px;
    background: #5b7bfe;
    border-radius: 4px;
    color: #ffffff;
    font-size: 12px;
    border: none;
    padding: 0 3px;
  }
}
.batchBox {
  display: flex;
  align-items: center;
  margin-right: 15px;
  // margin-bottom: 15px;
  // margin: 15px 0;
  background: #ccc;
  border-radius: 4px;
  height: 28px;
  .batchDelete {
    width: 74px;
    height: 100%;
    line-height: 28px;
    font-size: 12px;
    text-align: center;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    &.active {
      border: 1px solid #2762ff;
      background: #2762ff;
    }
    &.export {
      border: 1px solid #FF9B3B;
      background: #FF9B3B;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/statementSealFileExport.vue